import React from "react";
import { Box } from "@material-ui/core";
import { useGet } from "restful-react";

import { IMatchWithballDataResponse, getTeamWithballlData } from "apis";
import { groupWithBallByAction } from "utils";
import { EVENT_VALUES } from "modules/withball-data-input/constants";

import { ScoreRanking } from "./ScoreRanking";
import { AssistantRanking } from "./AssistantRanking";
import { PassRanking } from "./PassRanking";
import { TackleRanking } from "./TackleRanking";
import { InterceptionRanking } from "./InterceptionRanking";
import { DribbleRanking } from "./DribbleRanking";

interface IAnnualPlayerRankingProps {
  teamId: number;
  startTime: string;
  endTime: string;
}

const ACTIONS = [
  EVENT_VALUES.SHOOT,
  EVENT_VALUES.PASS,
  EVENT_VALUES.DRIBBLE,
  EVENT_VALUES.TACKLE,
  EVENT_VALUES.INTERCEPTION,
  EVENT_VALUES.DRIBBLE,
];

export const AnnualPlayerRanking = ({
  teamId,
  startTime,
  endTime,
}: IAnnualPlayerRankingProps) => {
  const { data } = useGet<IMatchWithballDataResponse>({
    path: getTeamWithballlData(teamId.toString(), ACTIONS, startTime, endTime),
  });

  const groupedData = groupWithBallByAction(data?.withballData || []);

  return (
    <>
      <Box mt={2} />
      <ScoreRanking data={groupedData[EVENT_VALUES.SHOOT.toString()]} />
      <AssistantRanking data={groupedData[EVENT_VALUES.SHOOT.toString()]} />
      <DribbleRanking data={groupedData[EVENT_VALUES.DRIBBLE.toString()]} />
      <PassRanking data={groupedData[EVENT_VALUES.PASS.toString()]} />
      <TackleRanking data={groupedData[EVENT_VALUES.TACKLE.toString()]} />
      <InterceptionRanking
        data={groupedData[EVENT_VALUES.INTERCEPTION.toString()]}
      />
    </>
  );
};
